import styled from "styled-components";

export const Square2Style = styled.div`
  width:100%;
  height:100%;

  .container3 {
    width:100%;
    height:100%;
    overflow: hidden;
    background: #a1dffb;
  }


  .back-layer {
    width: 100%;
    height: 100%;
    opacity: 0.6;
    clip-path: ellipse(0% 0% at 50% 0%);
  }

  .text-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 5%;
    }

  
  .text-wrapper div{
    width:100%
  }


  .back-layer img,
  .back-layer video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 150%;
  }
`;
